import { render, staticRenderFns } from "./EmptyCartPage.vue?vue&type=template&id=26dea855&scoped=true&"
import script from "./EmptyCartPage.vue?vue&type=script&lang=ts&"
export * from "./EmptyCartPage.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyCartPage.vue?vue&type=style&index=0&id=26dea855&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dea855",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VContainer})
